






































import VFaIcon from "@/components/VFaIcon.vue";

import { GetErrorImageCommand, GetErrorImageReqData } from "@/model/communication/status/GetErrorImageCommand";
import { GetErrorDetailsResData } from "@/model/communication/status/GetErrorDetailsResData";
import { GetErrorDetailsCommand, GetErrorDetailsReqData } from "@/model/communication/status/GetErrorDetailsCommand";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { GetErrorImageResData } from "@/model/communication/status/GetErrorImageResData";

export default {
    components: { VFaIcon },
    data() {
        return {
            errorImage: null,
            area: "",
            code: "",
            d1: "",
            board: "",
            exceptionTitle: "",
            exceptionDescription: "",
            loadingImage: false,
            caosError: "",
            intToHexModels: ["CDS 803-CCD", "CDS 804-CCD", "InLane CCR", "InLane CCR Depo", "InLane CCR Depo Plus"],
        };
    },
    props: {
        model: String,
        supportedCashType: {},
        errorMessage: String,
    },
    computed: {
        codeFormatted() {
            if (this.intToHexModels.includes(this.model) && this.code) return parseInt(this.code).toString(16).toUpperCase();
            return this.code;
        },
    },
    methods: {
        async getErrorImage() {
            let mask = null;

            // controllo se l'error è la mask diretta
            let found = this.errorMessage.match(/AREA:([ ]?)([0-9a-fA-F]*)/g);
            if (found && found.length == 1) mask = found[0].split(":")[1].trim();

            if (mask) {
                let splittedErrorMessage = this.errorMessage.split(":");
                for (let i = 0; i < splittedErrorMessage.length; i++) {
                    let mes = splittedErrorMessage[i].trim().toLowerCase();
                    if (splittedErrorMessage[i + 1] == null || splittedErrorMessage[i + 1] == undefined) continue;
                    if (mes.includes("area")) this.area = mask;
                    else if (mes.includes("code")) this.code = splittedErrorMessage[i + 1].trim().split(" ")[0];
                    else if (mes.includes("d1")) this.d1 = splittedErrorMessage[i + 1].trim().split(" ")[0];
                    else if (mes.includes("board")) this.board = splittedErrorMessage[i + 1].trim().split(" ")[0];
                }
                if (this.code == null || this.code == undefined || this.code == "") {
                    if (splittedErrorMessage && splittedErrorMessage.length > 2) {
                        this.code = splittedErrorMessage[1];
                        if (this.code != null && this.code != undefined && this.code.trim().toLowerCase().includes("d1")) {
                            this.code = this.code.trim().substring(0, this.code.trim().toLowerCase().indexOf("d1"));
                        }
                    }
                }
                let error = splittedErrorMessage[0].replace(/\D/g, "");
                try {
                    let reqData = new GetErrorDetailsReqData(this.model, this.code, this.area, this.supportedCashType, error);
                    let response: GetErrorDetailsResData = await new GetErrorDetailsCommand(reqData).execute();
                    if (response.responseStatus == ApiResponseStatusEnum.Success) {
                        let splittedCodeLabel = response.codeLabel.split(/\r?\n/);
                        if (splittedCodeLabel.length >= 2) {
                            let splittedLabel = splittedCodeLabel[0].split(":");
                            if (splittedLabel.length >= 2) {
                                this.exceptionTitle = splittedLabel[1].trim();
                                this.code = splittedLabel[0];
                            } else {
                                this.exceptionTitle = splittedCodeLabel[0];
                            }
                            this.exceptionDescription = splittedCodeLabel[1];
                        } else {
                            this.exceptionTitle = response.codeLabel;
                        }
                        if (response.areaLabel) this.area = response.areaLabel;
                        if (response.caosErrorLabel) this.caosError = `${response.caosErrorLabel} (${error})`;
                    }
                } catch (e) {
                    console.log("Something went wrong sending GetErrorDetailsCommand request ", e);
                }
                this.loadingImage = true;
                let responseImage: GetErrorImageResData = await new GetErrorImageCommand(new GetErrorImageReqData(this.model, mask, this.supportedCashType)).execute();
                this.loadingImage = false;

                if (responseImage.responseStatus == ApiResponseStatusEnum.Success) {
                    this.errorImage = responseImage.errorImage;
                } else this.errorImage = null;
            } else this.errorImage = null;
        },
    },
    mounted() {
        this.getErrorImage();
    },
};
